import * as Yup from 'yup';

export const MESSAGE_BAR_TYPES = {
  SUCCESS: "success",
  ERROR: "error",
  WARNING: "warning",
  INFO: "info",
};

export const screenHeightPercentages = (size) => {
  if (size >= 500 && size < 600) {
    return 75;
  }
  if (size >= 600 && size < 700) {
    return 65;
  }
  if (size >= 700 && size < 800) {
    return 55;
  }
  if (size >= 800 && size < 900) {
    return 50;
  }
  if (size >= 900 && size < 1000) {
    return 45;
  }
  return 40;
};

export const screenHeightPercentagesCurrency = (size) => {
  if (size >= 500 && size < 600) {
    return 40;
  }
  if (size >= 600 && size < 700) {
    return 45;
  }
  if (size >= 700 && size < 800) {
    return 50;
  }
  if (size >= 800 && size < 900) {
    return 55;
  }
  if (size >= 900 && size < 1000) {
    return 80;
  }
  return 80;
};


export const paymentOptions = {
  crypto: 'crypto',
  masspay: 'type-1',
  pockyt: 'type-2',
  xbd: 'type-3',
  cj: 'type-4',
  'type-1': 'type-1',
  'type-2': 'type-2',
  'type-3': 'type-3',
  'type-4': 'type-4',
}


export const masspayOptions = {

}
export const EVENTS = {
  'WITHDRAWAL': {
    'TRANSFER_BEGIN': 'TransferBegin',
    'TRANSFER_METHOD': 'TransferMethod',
    'CRYPTO_SELECTION': 'CryptoSelection',
    'WALLET_ADD': 'WalletAdd',
    'REMEMBER_WALLET': 'RememberWallet',
    'INITIATE_TRANSFER': 'InitiateTransfer',
    'CONFIRM_CRYPTO_TRANSFER': 'ConfirmCryptoTransfer',
    'FIAT_COUNTRY':'FiatCountry',
    'FIAT_METHOD': 'FiatMethod',
    'FIAT_FORM': 'FiatForm',
    'CONFIRM_FIAT_TRANSFER': 'ConfirmFiatTransfer'
  },
  RECURRING: {
    "GO_BACK_HOME": "RECURRING_GO_BACK_HOME"
  }

}

export const ACTIVITY_DETAIL = {
  'WITHDRAWAL': {
    'TRANSFER_BEGIN': 'User clicked on Transfer button',
    'TRANSFER_METHOD': 'User clicked and chose one of the payout methods',
    'CRYPTO_SELECTION': 'User clicked on one of the crypto currencies',
    'WALLET_ADD': 'User added wallet address',
    'REMEMBER_WALLET': 'User clicked toggled wallet',
    'INITIATE_TRANSFER': 'User clicked on transfer button on the transfer details screen where we show pricing, exchange rate, etc.',
  'CONFIRM_CRYPTO_TRANSFER': 'User confirmed the transfer details on the popup',
    'FIAT_COUNTRY': 'User confirmed the country',
    'FIAT_METHOD': 'User clicked on one of the methods',
    'FIAT_FORM': 'User completed the form entry and clicked the Next button',
    'CONFIRM_FIAT_TRANSFER': 'User confirmed the transfer details on the final review screen' 
  }
}
export const ACTIVITY_META = {
  'WITHDRAWAL': {
    'TRANSFER_BEGIN': 'Transfer process begins',
    'TRANSFER_METHOD': 'Clicked and chose one of the payout methods',
    'CRYPTO_SELECTION': 'Clicked on one of the crypto currencies',
    'WALLET_ADD': 'Wallet was added',
    'REMEMBER_WALLET': 'Remember wallet was clicked',
    'INITIATE_TRANSFER': 'Transfer button was clicked on the transfer details screen where we show pricing, exchange rate, etc.',
    'CONFIRM_CRYPTO_TRANSFER': 'User confirmed the transfer details on the popup'
  }
}

export const transferType = {
  fiat: ['masspay','pockyt', 'xbd', 'clear-junction'],
  crypto: ['fortress', 'fortress-test']
}
export const WALLET_ADD_METHODS = {
  MANUAL: 'MANUAL',
  CAMERA_SCAN:'CAMERA_SCAN'
};

export const RECURRING_METHODS = {
  CRYPTO: 'crypto'
}

export const USD = 'USD';
export const ETH = 'ETH';
export const ACTIVE_RECURRING_RULE = 1;
export const INACTIVE_RECURRING_RULE = -1;

export const LOCALSTORAGE_LANGUAGE_KEY = 'payout_app_language';

export const pockytValidation = Yup.object().shape({
  city: Yup.string().required('City is required'),
  bankRoutingNumber: Yup.string().matches(/^\d{9}$/, 'Invalid US bank routing number format')
      .required('Bank Routing Number is required'),
  bankAccountType: Yup.string().required('Bank Account Type is required'),
  bankAccountNumber: Yup.string()
      .matches(/^\d{9,30}$/, 'Invalid account number format') // Adjusted pattern with a maximum of 30 digits
      .required('Bank Account Number is required'),
  confirmBankAccountNumber: Yup.string()
      .oneOf([Yup.ref('bankAccountNumber'), null], 'Bank Account Numbers must match')
      .required('Confirm Bank Account Number is required'),

  address: Yup.string().required('Address is required')
});


export const TRANSFER_MODE = 'transfer-mode';
export const STATUS_MODE = 'status-mode';
export const BANK_MODE = 'bank-mode';
export const BANK_ITEM_LIST_ACTION = [
  'Delete',
];
export const fiatVendors = [paymentOptions.masspay, paymentOptions.pockyt, paymentOptions.xbd, paymentOptions.cj];

export const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;

export const TRACKING_TAGS = ['input', 'a', 'button', 'li'];